/**
 * Component: Products & Services
 * Requires flickity for the slideshow
 */

var ed = ed || {};

ed.productsServices = new function(){
    /**
     * Init function
     */
    this.init = function() {
        slideshow();
    };

    /**
     * Slideshow
     */
    function slideshow() {
        var productsServicesList = $('.products-services-list'),
            productsServicesItemSelector = '.products-services-item-container';

        // Remove display none class
        productsServicesList.removeClass('js-hidden');

        // Trigger redraw for transition
        productsServicesList.first().offsetHeight;

        // Init flickity
        productsServicesList.flickity({
            cellSelector: productsServicesItemSelector,
            accessibility: false,
            pageDots: false,
            contain: true,
            cellAlign: 'left',
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 40,
                x3: 30
            }
        });

        // Dispatch a resize event to make sure sliders aren't cut in half cause of weird load timings
        window.dispatchEvent(new Event('resize'));
    }
};
